<script setup lang="ts">
  // Props
  defineProps<{
    info?: ContentSection
    width?: string
  }>()
</script>
<template>
  <div class="mb-8">
    <p class="text-lg font-bold pb-2 w-fit bg-clip-text text-transparent bg-byhours-gradient">
      {{ info?.smallText }}
    </p>
    <h2 :class="['text-4xl', 'md:text-7xl', width]">
      {{ info?.titulo }}
    </h2>
    <p class="mt-4" v-if="info?.texto">
      {{ info?.texto }}
    </p>
  </div>
  <div class="content">
    <slot></slot>
  </div>
  <div class="mt-8" v-if="info?.button">
    <UButton
      color="neutral"
      :to="getButtonUrl(info?.button)"
      :aria-label="info?.button?.label"
      size="xl"
      :label="info?.button?.label"
    />
  </div>
</template>